1
<template>
  <div id="wrapper" class="d-flex">
    <div id="page-content-wrapper">
      <nav
        class="
            navbar navbar-expand-lg navbar-light
            bg-na-principal
            border-bottom
            fixed-top
            custom-navbar
          "
      >
        <div class="mx-n4 mx-md-0">
          <img alt="logo" height="63px" :src="logoImgUrl" width="190px" />
        </div>
      </nav>
    </div>
  </div>
</template>

<script>
import logoUrl from '@/assets/img/logo.svg';

export default {
  name: 'Navbar',
  data: () => ({
    logoImgUrl: logoUrl,
  }),
};
</script>

<style scoped lang="scss"></style>
